import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './providers/auth.provider'
import { NotificationProvider } from './providers/notification.provider'
import { AppRoutes } from './router'
import { ZendeskProvider } from './providers/zendesk.provider'
import SocketProvider from './providers/socket.provider'
import TestAccountPoolProvider from './providers/test-account-pool.provider'
import QueryClientProvider from './providers/query-client.provider'
import EnvironmentBanner from './components/environment-banner.component'
import { ErrorBoundary } from './components/error/error-boundary.component'

import { config } from './config'

const ZENDESK_KEY = config.ZENDESK_KEY

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>
          <ErrorBoundary>
            <QueryClientProvider>
              <SocketProvider>
                <ZendeskProvider apiKey={ZENDESK_KEY}>
                  <TestAccountPoolProvider>
                    <EnvironmentBanner />
                    <AppRoutes />
                  </TestAccountPoolProvider>
                </ZendeskProvider>
              </SocketProvider>
            </QueryClientProvider>
          </ErrorBoundary>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  )
}

export default App
